import { apiClient } from "./apiClient";
import { unwrapApiResponse } from "../shared/utils/apiResponse";

export type QuoteDocument = {
  id: number;
  displayName: string;
  originalFileName: string;
  fileType: string;
  contentType: string;
  fileSize: number;
  uploadedBy: string;
  uploadedAt: string;
};

export async function listQuoteDocuments() {
  const { data } = await apiClient.get("/quote-documents");
  const rows = unwrapApiResponse<QuoteDocument[]>(data);
  return Array.isArray(rows) ? rows : [];
}

export async function uploadQuoteDocument(displayName: string, file: File) {
  const form = new FormData();
  form.append("displayName", displayName);
  form.append("file", file);
  const { data } = await apiClient.post("/quote-documents", form, {
    headers: { "Content-Type": "multipart/form-data" }
  });
  return unwrapApiResponse(data);
}

export async function deleteQuoteDocument(id: number) {
  const { data } = await apiClient.delete(`/quote-documents/${id}`);
  return data;
}

export async function generateQuotePdf(payload: Record<string, unknown>) {
  const { data } = await apiClient.post("/pdf-reports/quote", payload, { responseType: "blob" });
  return data as Blob;
}
